module.exports = __webpack_public_path__ + "static/image/history/m/201403@3x.jpg?893a44eb";